const HistoricalFacts = () => {
    const facts = [
      {
        id: 1,
        title: "Операция «Багратион»",
        content: "Крупнейшая наступательная операция Красной армии в Великой Отечественной войне, проведённая с 23 июня по 29 августа 1944 года. Её целью было полное освобождение Беларуси от немецко-фашистских захватчиков и разгром группы армий «Центр». Операция получила название в честь полководца Отечественной войны 1812 года Петра Багратиона. \nПодготовка велась в строжайшей секретности: использовались маскировка, дезинформация противника (например, имитация сосредоточения войск на Украине). В операции участвовали четыре фронта (1-й, 2-й, 3-й Белорусские и 1-й Прибалтийский) под командованием Рокоссовского, Захарова, Черняховского и Баграмяна. Силы Красной армии насчитывали около 2,4 млн человек, 5,2 тыс. танков и 5,3 тыс. самолётов.",
        image: "/data/icons/bagration.png"
      },
      {
        id: 2,
        title: "Блокада Ленинграда",
        content: "Осада города немецкими, финскими и испанскими («Голубая дивизия») войсками длилась с 8 сентября 1941 года по 27 января 1944 года (872 дня). Целью гитлеровцев было уничтожение Ленинграда голодом и артобстрелами, чтобы «стереть с лица земли» колыбель революции. \n Прорыв блокады начался в январе 1943 года (операция «Искра»), а полное снятие — в январе 1944-го в ходе Ленинградско-Новгородской операции. Блокада стала примером массового героизма гражданского населения и военных.",
        image: "/data/icons/leningrad.jpeg"
      },
      {
        id: 3,
        title: "Курская дуга",
        content: "Крупнейшее сражение лета 1943 года (5 июля – 23 августа), в котором вермахт предпринял последнюю попытку перехватить стратегическую инициативу. Немецкая операция «Цитадель» предполагала окружение советских войск на Курском выступе силами групп армий «Центр» и «Юг» (командующие — фон Клюге и Манштейн). \n Курская битва ускорила открытие второго фронта в Европе и стала прологом к освобождению СССР.",
        image: "/data/icons/kursk.jpg"
      }
    ];
  
    return (
      <section className="w-full bg-[#00161D]" id='HistoricalFacts'>
        <div className="max-w-[1280px] mx-auto px-4">
          <h2 className="text-7xl font-bold text-center mb-20 text-[#E6F6FA] max-[768px]:text-5xl max-[768px]:text-5xl max-[425px]:text-4xl">
            Исторические факты
          </h2>
  
          {facts.map((fact, index) => (
            <div 
              key={fact.id}
              className={`mb-16 flex flex-col md:flex-row gap-8 items-center 
                ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}
            >
              <div className="w-full md:w-1/2 rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                <img
                  src={fact.image}
                  alt={fact.title}
                  className="w-full h-64 md:h-80 object-cover transform hover:scale-105 transition-transform"
                />
              </div>
  
              <div className="w-full md:w-1/2">
                <h3 className="text-2xl font-bold mb-4 text-[#E6F6FA]">{fact.title}</h3>
                <p className="text-[#E6F6FA] leading-relaxed">{fact.content}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  };
  
  export default HistoricalFacts;